
//ovo matar os cukies
//sugestão: trocar para localStorage
module.exports = {
  cookies: {
    set: (name, value, days = 30) => {
      let date = new Date();
      date.setTime(+ date + (days * 86400000));
      date = date.toUTCString();
      date = `; expires=${date}; path=/`;
      value = encodeURI(value);
      document.cookie = name + '=' + value + (date || '');
    },
    del: (name) => {
      let date = new Date(2000,0,1);
      date = date.toUTCString();
      document.cookie = `${name}=; expires=${date}; path=/`;
    },
    get: (name) => {
      name = name + '=';
      let cookies = document.cookie ? document.cookie : '';
      let nameIndex = cookies.indexOf(name);
      if (nameIndex == '-1') return undefined;
      cookies = cookies.substr(nameIndex, cookies.length);
      if (cookies.indexOf(';') > -1) cookies = cookies.split(';')[0];
      cookies = cookies.split('=')[1];
      return decodeURI(cookies);
    }
  }
}
